import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-checkmark-indicator',
  templateUrl: './checkmark-indicator.component.html',
  styleUrls: ['./checkmark-indicator.component.scss']
})
export class CheckmarkIndicatorComponent {
  @Input() isChecked: boolean = false;
  @Input() showIsNotCheckedIndicator: boolean = true;
}
